<template lang="pug">
    div.arrow-return(@click="click")
      i.el-icon-arrow-left.icon-r
</template>

<script>

export default {
  name: 'ArrowReturn',
  methods: {
    click(event) {
        this.$emit("arrow-return");
    }
  },
}
</script>

<style scoped>
@import 'arrow-return.scss';
</style>

